<template>
  <c-modal title="Change password" size="" :show="show" @update:show="toggle">
    <c-form>
      <c-input
        v-model="password"
        autofocus
        autocomplete="off"
        label="New password"
        type="password"
        placeholder="Enter new password"
        :is-valid="checkIfValid('password')"
        invalid-feedback="Please enter a new password"
      />
      <c-input
        v-model="confirmPassword"
        autofocus
        autocomplete="off"
        label="Confirm password"
        type="password"
        placeholder="Re-enter your new password"
        :is-valid="checkIfValid('confirmPassword')"
        invalid-feedback="Passwords do not match"
      />
    </c-form>
    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" @click="changePassword">
          <c-spinner v-if="isChanging" color="success" size="sm" />
          <span v-else>Change password</span>
        </c-button>
        <c-button v-if="!isChanging" color="secondary" @click="close">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required, minLength, sameAs, helpers,
} from 'vuelidate/lib/validators';

import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  mixins: [validationMixin],
  props: {
    user: Object,
    show: Boolean,
  },
  data() {
    return {
      error: null,
      isChanging: false,
      password: '',
      confirmPassword: '',
      data: {
        body: {
          password: '',
          confirmPassword: '',
        },
      },
      requiredFields: {
        'data.body.password': false,
        'data.body.confirmPassword': false,
      },
    };
  },
  computed: {
    isValid() {
      return !this.$v.$invalid;
    },
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
      strongPass: helpers.regex('strongPass', /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/),
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    close() {
      this.reset();
      this.$emit('close');
    },
    reset() {
      this.password = '';
      this.confirmPassword = '';
    },
    changePassword() {
      this.$v.$touch();
      if (!this.isValid) {
        return;
      }

      this.isChanging = true;
      this.error = null;
      const data = {
        id: this.user._id,
        password: this.password,
        confirmPassword: this.confirmPassword,
      };
      this.$http
        .post(buildEndpoint('my-account/change-password'), data)
        .then((response) => {
          this.isChanging = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Password changed',
            });
            this.reset();
            this.$emit('updateRequested');
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        })
        .finally(() => {
          this.$v.$reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.error-message {
  margin-bottom: 20px;
}
</style>
